export function skillLabels(skill) {
  const skillMap = {
    guard: 'Guard',
    guardPassing: 'Guard passing',
    sweep: 'Sweep',
    positionDefense: 'Position defense',
    submissionDefense: 'Submission defense',
    submission: 'Submission',
    takedown: 'Takedown',
    guardRecovery: 'Guard recovery',
    technique: 'Technique',
    strength: 'Strength',
    agility: 'Agility',
    stamina: 'Stamina',
    commitment: 'Commitment',
    focus: 'Focus',
  }

  return skillMap[skill] || ''
}
